export default __webpack_public_path__ + "static/ata-41203743717d3de6324cd98baebcfcb4.png";